// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"control-platform"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 2L21 7V17L12 22L3 17V7L12 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 12L20.5 7.5M12 12V21.5M12 12L3.5 7.5M12 2L21 7V17L12 22L3 17V7L12 2Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-control-platform')
export default class ControlPlatformIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'control-platform',
    }
  }
}
